import {MAP_TOOLS} from '@app/constants';

export const aoiTooltipMap = {
  [MAP_TOOLS.DRAW_LOCKED_CIRCLE]:
    'Draw a constrained circular area of interest',
  [MAP_TOOLS.DRAW_LOCKED_RECT]:
    'Draw a constrained rectangular area of interest',
  [MAP_TOOLS.DRAW_POLYGON]: 'Draw a custom area of interest',
  [MAP_TOOLS.DRAW_CIRCLE]: 'Draw a circular area of interest',
  [MAP_TOOLS.DRAW_RECT]: 'Draw a rectangular area of interest',
  [MAP_TOOLS.EDIT]: 'Edit AOI',
  CLEAR: 'Clear AOI',
};

export const measureTooltipMap = {
  [MAP_TOOLS.DRAW_POLYGON]: 'Measure an area',
  [MAP_TOOLS.DRAW_LINE]: 'Measure a distance',
  [MAP_TOOLS.EDIT]: 'Edit measurement',
  CLEAR: 'Remove measurement from map',
};
